import { connect } from 'react-redux';
import SlackView from './SlackView.jsx';
import { getIntegrationForType, fetchIntegrations } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/slack.jsx';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
    let integration = getIntegrationForType(state, 'slack');
    return {
        integration: integration,
        integrations: state.legacyRootReducer.settings.integrations,
        deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
        user: _.get(state, 'users.me',""),
        integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading' ,false)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        authenticateAccount: (code, type) => {
            return dispatch(authenticateAccount(code, type));
        },

        fetchIntegrations: () => {
            return dispatch(fetchIntegrations());
        },
        trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
            return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
        }
    }
}

const SlackPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(SlackView);

export default withUseHooks(SlackPage);